<template>
  <div class="hairdressing">
    <HairdressingManager/>
  </div>
</template>

<script>
  import HairdressingManager from '../components/HairdressingManager';
  
  export default {
    name: 'hairdressing',
    components: {
      HairdressingManager,
    },
  }
</script>

<style scoped>
  .hairdressing {
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
</style>
